import React from 'react';
import Table from './Structures/Table';

const parseReportData = (report) => {
  // Default parsedData structure
  let parsedData = {
    lobbyists: [],
    companies: [],
    newContracts: [],
    terminatedContracts: [],
  };

  // Check if report is undefined or not a string
  if (typeof report !== 'string' || report.trim() === '') {
    return parsedData;
  }

  // Regex for contract lines that captures lobbyist, company, start, and end dates.
  const contractRegex = /- Lobbyist:\s*(.+?),\s*Company:\s*(.+?),\s*Start:\s*(.+?),\s*End:\s*(.+)/;

  // Split report into sections based on headers starting with "New" or "Terminated"
  const sections = report.split(/\n(?=New |Terminated )/);

  sections.forEach((section) => {
    if (section.startsWith('New Lobbyists:')) {
      parsedData.lobbyists = section
        .split('\n')
        .slice(1)
        .filter((line) => line.startsWith('-'))
        .map((line) => line.slice(2).trim());
    } else if (section.startsWith('New Companies:')) {
      parsedData.companies = section
        .split('\n')
        .slice(1)
        .filter((line) => line.startsWith('-'))
        .map((line) => line.slice(2).trim());
    } else if (section.startsWith('New Contracts:') || section.startsWith('New or Updated Contracts:')) {
      parsedData.newContracts = section
        .split('\n')
        .slice(1)
        .filter((line) => line.trim())
        .map((line) => {
          const match = line.match(contractRegex);
          if (match) {
            return {
              lobbyist: match[1].trim(),
              company: match[2].trim(),
              start: match[3].trim(),
              end: match[4].trim(),
            };
          }
          return null;
        })
        .filter(Boolean);
    } else if (section.startsWith('Terminated')) {
      parsedData.terminatedContracts = section
        .split('\n')
        .slice(1)
        .filter((line) => line.trim())
        .map((line) => {
          const match = line.match(contractRegex);
          if (match) {
            return {
              lobbyist: match[1].trim(),
              company: match[2].trim(),
              start: match[3].trim(),
              end: match[4].trim(),
            };
          }
          return null;
        })
        .filter(Boolean);
    }
  });

  console.log(parsedData.terminatedContracts);
  return parsedData;
};

const LobbyReportTable = ({ report }) => {
  const { lobbyists, companies, newContracts, terminatedContracts } = parseReportData(report);

  const getYesterdayDate = () => {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    return yesterday.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  return (
    <div className="grid grid-cols-2 gap-6 w-full h-[calc(100vh-330px)] overflow-y-auto">
      <div className="bg-[#F9FAFB] border border-[#E5E7EB] py-[15px] px-5">
        <div className="border-b border-[#E5E7EB] mb-3 pb-2.5 flex flex-col justify-between">
          <h2 className="font-playfair text-[24px] text-darkblue font-medium leading-8">
            Daily Lobby Report for {getYesterdayDate()}
          </h2>
        </div>
        <h6 className="mb-2">This report is generated off of yesterday's filings.</h6>
        <div className="reportContent">
          <h2 className="font-playfair text-[18px] text-darkblue font-medium leading-8">New Lobbyists</h2>
          <ul className="lobbyList">
            {lobbyists &&
              lobbyists.length > 0 &&
              lobbyists.map((lobbyist, index) => (
                <li className="lobbyItem" key={index}>
                  {lobbyist}
                </li>
              ))}
          </ul>

          <h2 className="font-playfair text-[18px] text-darkblue font-medium leading-8 mt-2">New Companies</h2>
          <ul className="companyList">
            {companies &&
              companies.length > 0 &&
              companies.map((company, index) => (
                <li className="companyItem" key={index}>
                  {company}
                </li>
              ))}
          </ul>
        </div>
      </div>

      <div className="bg-white shadow rounded-lg p-6 border border-gray-200">
        <section className="mb-6">
          <h3 className="text-xl font-semibold text-gray-700 border-b pb-2 mb-3">New or Updated Contracts</h3>
          {newContracts.length > 0 ? (
            <Table
              headers={['Lobbyist', 'Company', 'Start', 'End']}
              rows={newContracts.map((contract) => [
                contract.lobbyist || '',
                contract.company || '',
                contract.start || '',
                contract.end || '',
              ])}
              loading={false}
            />
          ) : (
            <p className="text-gray-500 text-sm mt-2">No new or updated contracts.</p>
          )}
        </section>

        <section>
          <h3 className="text-xl font-semibold text-gray-700 border-b pb-2 mb-3">Terminated Contracts</h3>
          {terminatedContracts.length > 0 ? (
            <Table
              headers={['Lobbyist', 'Company', 'Start', 'End']}
              rows={terminatedContracts.map((contract) => [
                contract.lobbyist || '',
                contract.company || '',
                contract.start || '',
                contract.end || '',
              ])}
              loading={false}
            />
          ) : (
            <p className="text-gray-500 text-sm mt-2">No terminated contracts.</p>
          )}
        </section>
      </div>
    </div>
  );
};

export default LobbyReportTable;
